<template>
  <div class="pair-toggle">
    <!-- O que se escolhe, em cima (pedido do usuário: "Cardinalidade", "Obrigatoriedade"…) — os dois
         lados dizem as respostas, e não a pergunta. O rótulo do sim/não do item (`BooleanInput`): o grupo
         de botões não é um campo do Vuetify, e não o desenha -->
    <label v-if="label" class="ontos-field-label">{{ label }}</label>
    <!-- O arranjo do Sim/Não do item (`BooleanInput`): dois botões divididos, com ícone, o escolhido
         destacado. `mandatory`: um dos dois lados está sempre escolhido -->
    <v-btn-toggle :model-value="modelValue" mandatory divided density="comfortable" variant="outlined"
                  :disabled="disabled" @update:model-value="$emit('update:modelValue', $event)">
      <v-btn :value="false">
        <v-icon v-if="off.icon" start>{{ off.icon }}</v-icon>{{ off.label }}
      </v-btn>
      <v-btn :value="true" :color="on.color">
        <v-icon v-if="on.icon" start>{{ on.icon }}</v-icon>{{ on.label }}
      </v-btn>
    </v-btn-toggle>
    <!-- A frase do lado escolhido: o que ele faz (pedido do usuário: "gosto de frase explicativa"). Travado,
         a frase é o porquê, à vista: só no passar do mouse, ninguém o achava (relato do usuário: "por que
         não pode mudar de preenchido para calculado?") -->
    <div class="pair-toggle-hint text-body-2 text-medium-emphasis">
      <template v-if="disabled && disabledReason"><v-icon size="small" start>mdi-lock</v-icon>{{ disabledReason }}</template>
      <template v-else>{{ modelValue ? on.hint : off.hint }}</template>
    </div>
    <!-- O que só vale com o lado ligado — o mínimo e o máximo do "Vários valores" -->
    <div v-if="modelValue && $slots.default" class="pair-toggle-more"><slot/></div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/** Um lado do par: o rótulo do botão, o ícone, a frase do que ele faz e — no lado ligado — a cor. */
export type PairSide = { label: string, hint: string, icon?: string, color?: string }

/**
 * Uma escolha de sim/não dita pelos dois lados — "Opcional · Obrigatório" —, no lugar da caixa de marcar
 * (ideia do usuário): os dois botões do Sim/Não do item, e embaixo a frase do lado escolhido.
 *
 * Os dois lados por extenso dizem mais que um rótulo e uma caixa: quem lê vê também o que vale quando
 * NÃO marca. Travado (`disabled`), diz o porquê no lugar da frase (`disabledReason`).
 */
@Component({name: 'ontos-pair-toggle', emits: ['update:modelValue']})
class PairToggle extends Vue {
  @Prop({type: Boolean, default: false}) readonly modelValue!: boolean
  @Prop({type: String, default: ''}) readonly label!: string
  @Prop({type: Object, required: true}) readonly off!: PairSide
  @Prop({type: Object, required: true}) readonly on!: PairSide
  @Prop({type: Boolean, default: false}) readonly disabled!: boolean
  @Prop({type: String, default: ''}) readonly disabledReason!: string
}

export default toNative(PairToggle)
</script>

<style scoped>
.pair-toggle-hint {
  margin-top: 4px;
}

/* O que depende do lado ligado, recuado embaixo da frase */
.pair-toggle-more {
  margin-top: 8px;
  padding-left: 16px;
}
</style>
